import { usePlaylistStore } from "@/stores/playlist.js";
import { scrollToSlide } from '@/Helpers/scroll.js'

export function resizeViewport() {
    const plStore = usePlaylistStore();
    document.documentElement.style.setProperty(
        "--vh",
        window.innerHeight * 0.01 + "px"
    );
    plStore.screenHeight = window.innerHeight;

    var vw = Math.min(document.documentElement.clientWidth, 512);
    var vhh = Math.min(document.documentElement.clientHeight, 1000);
    document.documentElement.style.setProperty(
        "--font-scale",
        calculateFontScale(vw * vhh)
    );
    plStore.setFontScale(calculateFontScale(vw * vhh));

    // Added to handle making sure the scroll position is correct after resizing
    scrollToSlide(plStore.currentSlideIndex);
}

export function handleOrientationChange() {
    const plStore = usePlaylistStore();
    if (window.innerHeight <= window.innerWidth) {
        plStore.setOrientation("portrait-primary");
    } else {
        plStore.setOrientation("portrait-primary");
    }
    if (plStore.orientation === "portrait-primary") {
        // portrait mode
    } else if (plStore.orientation === "landscape-primary") {
        // landscape mode
    }

    // Added to handle making sure the scroll position is correct after resizing
    scrollToSlide(plStore.currentSlideIndex);
}

function calculateFontScale(number) {
    const lowerBound = 125000;
    const upperBound = 400000;
    const lowerValue = 0.5;
    const upperValue = 1.25;

    // For numbers at or below the lower bound
    if (number <= lowerBound) {
        return lowerValue;
    }
    // For numbers at or above the upper bound
    else if (number >= upperBound) {
        return upperValue;
    }
    // For numbers in between
    else {
        // Calculate the slope of the line connecting the points (lowerBound, lowerValue) and (upperBound, upperValue)
        const slope = (upperValue - lowerValue) / (upperBound - lowerBound);
        // Calculate the value by applying the line equation y = mx + b, where m is the slope and b is the y-intercept
        const value = slope * (number - lowerBound) + lowerValue;
        return value;
    }
}
